import type { TextProps } from '@wartek-id/text-v1'
import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'
import type { TAtasanStatus } from 'types/kinerja-atasan'

export type LabelProps = {
  status: TAtasanStatus
  value: string
  endsWithDot?: boolean
} & Omit<TextProps, 'children'>

export const Label: FC<LabelProps> = ({
  status,
  value,
  endsWithDot = false,
  ...props
}) => {
  if (status === 'REJECTED')
    return <Text {...props}>Data salah{endsWithDot && '.'}</Text>

  if (status === null || !value)
    return <Text {...props}>Tidak ada{endsWithDot && '.'}</Text>

  return (
    <Text title={value} {...props}>
      {value}
    </Text>
  )
}
